import { defaultEventBus } from '../../EventBus/defaultEventBus.js';
export const useDialogManager = () => ({
    open: (dialog, options = {}) => defaultEventBus.fire('dialog', { type: 'open', dialog, ...options }),
    close: () => defaultEventBus.fire('dialog', { type: 'close' }),
    closeAll: () => defaultEventBus.fire('dialog', { type: 'close', all: true }),
});
//# sourceMappingURL=useDialogManager.js.map